module.exports = __webpack_public_path__ + "static/media/pin-default.03816fa6.png";